import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../store/store';

/**
 * Schedules an automatic logout when the session expiry time is reached.
 * Also handles the case where the session is already expired on mount (e.g. after a browser restart).
 * Should be used inside authenticated routes only.
 */
export const useAutoLogout = () => {
  const sessionExpiry = useStore((state) => state.sessionExpiry);
  const logout = useStore((state) => state.logout);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionExpiry) return;

    const remaining = sessionExpiry - Date.now();

    if (remaining <= 0) {
      logout();
      navigate('/login', { replace: true });
      return;
    }

    const timer = setTimeout(() => {
      logout();
      navigate('/login', { replace: true });
    }, remaining);

    return () => clearTimeout(timer);
  }, [sessionExpiry, logout, navigate]);
};
